export const testTrue = () => {
  return {
    type: "testTrue",
  };
};
export const testFalse = () => {
  return {
    type: "testFalse",
  };
};

export const saveSpecifications = (specifications) => {
  return {
    type: "SAVE_SPECIFICATIONS",
    payload: specifications,
  };
};

export const saveWriterText = (specifications) => {
  return {
    type: "SAVE_Writers",
    payload: specifications,
  };
};

export const triggerReload = () => {
  return {
    type: "TRIGGER_RELOAD",
  };
};

export const resetReload = () => {
  return {
    type: "RESET_RELOAD",
  };
};
